
import itJson from './it.json';
import geJson from './ge.json';
import roJson from './ro.json';
import poJson from './po.json';
import czJson from './cz.json';
import huJson from './hu.json';

export const translations = {
  it: itJson,
  ge: geJson,
  ro: roJson,
  po: poJson,
  cz: czJson,
  hu: huJson,
};